import { render, staticRenderFns } from "./FreshWaterIntake.vue?vue&type=template&id=fe955810&scoped=true&"
import script from "./FreshWaterIntake.vue?vue&type=script&lang=js&"
export * from "./FreshWaterIntake.vue?vue&type=script&lang=js&"
import style0 from "./FreshWaterIntake.vue?vue&type=style&index=0&id=fe955810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe955810",
  null
  
)

export default component.exports